export const SHOW_ADD_USER = 'events/SHOW_ADD_USER';

/**
 * @return {{type: string}}
 */
export const showAddUser = (show) => ({
  type: SHOW_ADD_USER,
  payload: show,
});
